module.exports = __webpack_public_path__ + "static/media/1_pl.2751b315.png";